<qbe-panel-component>
  <div nxRow class="page-container">
    <div nxCol="12,12,6,6" class="u-df-c">
      <div class="page-illustration">
        <qbe-illustration name='fatherAndChildrenWithSuitcases'></qbe-illustration>
      </div>
    </div>
    <div nxCol="12,12,6,6">
      <h2 nxHeadline="section" class="u-text-center nx-margin-bottom-2m"> {{ "home.title" | translate }} </h2>
      <app-radio-buttons [options]="horizontalButtons" [selected]="processKind$ | async" (change)="handleChange($event)" />
    </div>
  </div>
</qbe-panel-component>

